  class ProductMedia extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    slider: "[data-slider]",
                    mediaItem: "[data-media-id]",
                    modalOpeners: "[data-modal-opener-id]",
                    zoomImages: "[data-pswp-image]",
                    btnXr: "[data-shopify-xr]",
                };
                
                this.selectedMediaIndex =
                    Number(
                        this.querySelector(this.selectors.slider).querySelector(
                            "[data-selected]"
                        )?.dataset.index
                    ) || 0;

                const swiperElement = document.getElementById("product__media-slider");
                let swiperOptions = {};
                try {
                    const optionsString = this.querySelector(
                        this.selectors.slider
                    ).getAttribute("data-swiper-options");
                    swiperOptions = optionsString ? JSON.parse(optionsString) : {};
                } catch (error) {
                    console.error("Invalid JSON in data-swiper-options:", error);
                }

                const withThumbs = this.dataset.withThumbs === "true";
                
                // Flag to distinguish between user clicks and programmatic changes
                this.isUserInitiatedChange = false;

                this.settings = {
                    sliderElement: this.querySelector(this.selectors.slider),
                    sliderInstance: null,
                    options: {
                        ...swiperOptions,
                        initialSlide: this.selectedMediaIndex,
                        navigation: {
                            prevEl: this.querySelector(".swiper-button-prev"),
                            nextEl: this.querySelector(".swiper-button-next"),
                        },
                        pagination: {
                            el: ".swiper-pagination",
                            type: "progressbar",
                        },
                        spaceBetween: 2,
                        watchOverflow: true,
                        watchSlidesVisibility: true,
                        watchSlidesProgress: true,
                        preventInteractionOnTransition: false,
                        autoHeight: this.dataset.autoHeight === "true",
                        loop: true,
                        allowTouchMove: true,
                        createElements: true,
                        speed: 600,
                        effect: "fade",
                        fadeEffect: {
                            crossFade: true,
                        },
                        breakpoints: {
                            750: {
                                navigation: {
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                            },
                        },
                        on: {
                            afterInit: (swiper) => this.afterInit(swiper),
                            slideChangeTransitionEnd: (swiper) =>
                                this.setActiveModalOpener(swiper),
                            transitionEnd: (swiper) => this.playActiveSlideVideo(swiper),
                            slideChange: (swiper) => this.syncThumbnails(swiper),
                        },
                    },
                };

                if (withThumbs) {
                    this.initThumbnails(swiperElement);
                } else {
                    this.settings.options.slidesPerView = 1;
                }
            }

            afterInit(swiper) {
                if (swiper.slides.length > 1) {
                    this.playActiveSlideVideo(swiper);
                }
            }

            pauseAllVideos(swiper) {
                swiper.el.querySelectorAll("video").forEach((video) => video.pause());
            }

            playActiveSlideVideo(swiper) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                if (!activeSlide) return;
                const video = activeSlide.querySelector("video");
                if (video) this.playPromise(video);
            }

            playPromise(video) {
                let playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(() => video.pause());
                }
            }

            initThumbnails(swiperElement) {
                const slideCount = this.querySelectorAll("[data-media-id]").length;

                this.thumbSwiper = new Swiper(".swiper-thumbs", {
                    initialSlide: this.selectedMediaIndex,
                    loopedSlides: slideCount,
                    direction: "horizontal",
                    centeredSlides: false,
                    slidesPerView: 3.5,
                    spaceBetween: 8,
                    centeredSlides: false,
                    freeMode: false,
                    watchSlidesProgress: true,
                    watchSlidesVisibility: true,
                    allowTouchMove: true,
                    threshold: 5,
                    breakpoints: {
                        750: {
                            loop: true,
                            spaceBetween: 8,
                            slidesPerView: "auto",
                            centeredSlides: false,
                            slideToClickedSlide: false,
                            direction: "vertical",
                        },
                    },
                });

                this.settings.options.thumbs = {
                    swiper: this.thumbSwiper,
                    slideThumbActiveClass: "swiper-slide-thumb-active",
                    autoScrollOffset: 0,
                    multipleActiveThumbs: false,
                };

                // Handle thumbnail clicks manually
                this.thumbSwiper.on("click", (swiper, event) => {
                    const clickedSlide = event.target.closest(".swiper-slide");
                    if (!clickedSlide) return;

                    const clickedMedia = clickedSlide.querySelector("[data-media-id]");
                    if (!clickedMedia) return;

                    const targetMediaId = clickedMedia.dataset.mediaId;

                    // Set flag to indicate this is a user-initiated change
                    this.isUserInitiatedChange = true;

                    // Find matching slide in main slider
                    const mainSlides = this.settings.sliderInstance.slides;
                    for (let i = 0; i < mainSlides.length; i++) {
                        const mainSlide = mainSlides[i];
                        if (mainSlide.dataset.mediaId === targetMediaId) {
                            this.settings.sliderInstance.slideTo(i);
                            break;
                        }
                    }
                });
            }

            updateThumbnailActiveState(mainSwiper) {
                const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
                if (!activeSlide) return;

                const activeMediaId = activeSlide.dataset.mediaId;

                // Remove active class from all thumbnails
                this.thumbSwiper.slides.forEach((thumbSlide) => {
                    thumbSlide.classList.remove("swiper-slide-thumb-active");
                });

                // Add active class to matching thumbnail
                this.thumbSwiper.slides.forEach((thumbSlide) => {
                    const thumbMedia = thumbSlide.querySelector("[data-media-id]");
                    if (thumbMedia && thumbMedia.dataset.mediaId === activeMediaId) {
                        thumbSlide.classList.add("swiper-slide-thumb-active");
                    }
                });
            }

            // Check if a slide is currently visible in the thumbnail swiper
            isThumbSlideVisible(slideIndex) {
                if (!this.thumbSwiper) return false;
                
                const slide = this.thumbSwiper.slides[slideIndex];
                if (!slide) return false;
                
                const swiperContainer = this.thumbSwiper.el;
                const slideRect = slide.getBoundingClientRect();
                const containerRect = swiperContainer.getBoundingClientRect();
                
                // Check if slide is at least partially visible
                return (
                    slideRect.left < containerRect.right &&
                    slideRect.right > containerRect.left &&
                    slideRect.top < containerRect.bottom &&
                    slideRect.bottom > containerRect.top
                );
            }

    // Improved syncThumbnails method - prevent ALL scrolling during navigation

   syncThumbnails(mainSwiper) {
                if (!this.thumbSwiper) return;

                const realIndex = mainSwiper.realIndex;

                if (this.isUserInitiatedChange) {
                    this.isUserInitiatedChange = false;
                    return;
                }


                const activeThumbIndex = this.getThumbIndexByMediaId(mainSwiper.slides[mainSwiper.activeIndex].dataset.mediaId);
                
                if (activeThumbIndex !== -1 && !this.isThumbSlideVisible(activeThumbIndex)) {
                    // Only scroll if the active thumbnail is not visible
                    this.thumbSwiper.slideToLoop(realIndex, 300);
                }
    }

      

            // Helper method to find thumbnail index by media ID
            getThumbIndexByMediaId(mediaId) {
                for (let i = 0; i < this.thumbSwiper.slides.length; i++) {
                    const thumbMedia = this.thumbSwiper.slides[i].querySelector("[data-media-id]");
                    if (thumbMedia && thumbMedia.dataset.mediaId === mediaId) {
                        return i;
                    }
                }
                return -1;
            }

            connectedCallback() {
                this.init();
            }

            init() {
                if (!this.settings.sliderElement) return;
                this.settings.sliderInstance = new Swiper(
                    this.settings.sliderElement,
                    this.settings.options
                );
            }

            setActiveModalOpener(swiper) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                if (!activeSlide) return;
                const activeMediaId = activeSlide.dataset.mediaId;
                this.querySelector(
                    `${this.selectors.modalOpeners}.is-active`
                )?.classList.remove("is-active");
                this.querySelector(
                    `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
                )?.parentElement.classList.add("is-active");
                if (activeSlide.dataset.mediaType === "model") {
                    this.querySelector(this.selectors.btnXr).dataset.shopifyModel3dId =
                        activeMediaId;
                }
            }
        }

        customElements.define("product-media", ProductMedia);


// class ProductMedia extends HTMLElement {
//   constructor() {
//     super();

//     this.selectors = {
//       slider: "[data-slider]",
//       mediaItem: "[data-media-id]",
//       modalOpeners: "[data-modal-opener-id]",
//       zoomImages: "[data-pswp-image]",
//       btnXr: "[data-shopify-xr]",
//     };
//     this.selectedMediaIndex =
//       Number(
//         this.querySelector(this.selectors.slider).querySelector(
//           "[data-selected]"
//         )?.dataset.index
//       ) || 0;

//     const swiperElement = document.getElementById("product__media-slider");
//     let swiperOptions = {};
//     try {
//       const optionsString = this.querySelector(
//         this.selectors.slider
//       ).getAttribute("data-swiper-options");
//       swiperOptions = optionsString ? JSON.parse(optionsString) : {};
//     } catch (error) {
//       console.error("Invalid JSON in data-swiper-options:", error);
//     }

//     const withThumbs = this.dataset.withThumbs === "true";

//     this.settings = {
//       sliderElement: this.querySelector(this.selectors.slider),
//       sliderInstance: null,
//       options: {
//         ...swiperOptions,
//         initialSlide: this.selectedMediaIndex,
//         navigation: {
//           prevEl: this.querySelector(".swiper-button-prev"),
//           nextEl: this.querySelector(".swiper-button-next"),
//         },
//         pagination: {
//           el: ".swiper-pagination",
//           type: "progressbar",
//         },
//         spaceBetween: 2,
//         watchOverflow: true,
//         watchSlidesVisibility: true,
//         watchSlidesProgress: true,
//         preventInteractionOnTransition: false,
//         autoHeight: this.dataset.autoHeight === "true",
//         loop: true,
//         allowTouchMove: true,
//         createElements: true,
//         speed: 600,
//         effect: "fade",
//         fadeEffect: {
//           crossFade: true,
//         },
//         breakpoints: {
//           750: {
//             navigation: {
//               nextEl: ".swiper-button-next",
//               prevEl: ".swiper-button-prev",
//             },
//           },
//         },
//         on: {
//           afterInit: (swiper) => this.afterInit(swiper),
//           slideChangeTransitionEnd: (swiper) =>
//             this.setActiveModalOpener(swiper),
//           transitionEnd: (swiper) => this.playActiveSlideVideo(swiper),
//           slideChange: (swiper) => this.syncThumbnails(swiper),
//         },
//       },
//     };

//     if (withThumbs) {
//       this.initThumbnails(swiperElement);
//     } else {
//       this.settings.options.slidesPerView = 1;
//     }
//   }

//   afterInit(swiper) {
//     if (swiper.slides.length > 1) {
//       this.playActiveSlideVideo(swiper);
//     }
//   }

//   pauseAllVideos(swiper) {
//     swiper.el.querySelectorAll("video").forEach((video) => video.pause());
//   }

//   playActiveSlideVideo(swiper) {
//     const activeSlide = swiper.slides[swiper.activeIndex];
//     if (!activeSlide) return;
//     const video = activeSlide.querySelector("video");
//     if (video) this.playPromise(video);
//   }

//   playPromise(video) {
//     let playPromise = video.play();
//     if (playPromise !== undefined) {
//       playPromise.catch(() => video.pause());
//     }
//   }

//   initThumbnails(swiperElement) {
//     const slideCount = this.querySelectorAll("[data-media-id]").length;


//   // initThumbnails(swiperElement) {
//   //   const thumbSwiper = new Swiper(".swiper-thumbs", {
//   //     initialSlide: this.selectedMediaIndex,
//   //     centeredSlides: false,
//   //     centeredSlidesBounds: true,
//   //     freeMode: false,
//   //     direction: "horizontal",
//   //     slidesPerView: 3.5,
//   //     spaceBetween: 8,
//   //     threshold: 5,
//   //     watchOverflow: true,
//   //     watchSlidesVisibility: true,
//   //     watchSlidesProgress: true,
//   //     breakpoints: {
//   //       750: {
//   //         direction: swiperElement.dataset.thumbsDirectionDesktop || "vertical",
//   //         spaceBetween: 8,
//   //         slidesPerView: 3.5,
//   //       },
//   //     },
//   //   });

//     this.thumbSwiper = new Swiper(".swiper-thumbs", {
//       initialSlide: this.selectedMediaIndex,
//       loopedSlides: slideCount,
//       direction: "horizontal",
//        centeredSlides: false,
//       slidesPerView: 3.5,
//       spaceBetween: 8,
//       centeredSlides: false,
//       freeMode: false,
//       watchSlidesProgress: true,
//       watchSlidesVisibility: true,
//       allowTouchMove: true,
//       threshold:5,
//       breakpoints: {
//         750: {
//           loop:true,
//           spaceBetween: 12,
//           slidesPerView: "auto",
//           centeredSlides: false,
//           slideToClickedSlide: false,
//           direction: "vertical",
//         },
//       },
//     });

//     // Link main slider to thumbnails
//     // this.settings.options.loopedSlides = slideCount;
//     this.settings.options.thumbs = {
//       swiper: this.thumbSwiper,
//       slideThumbActiveClass: "swiper-slide-thumb-active",
//       autoScrollOffset: 0,
//       multipleActiveThumbs: false,
//     };

//     // Handle thumbnail clicks manually to avoid loop index conflicts
//     this.thumbSwiper.on("click", (swiper, event) => {
//       const clickedSlide = event.target.closest(".swiper-slide");
//       if (!clickedSlide) return;

//       // Get the media ID from the clicked thumbnail
//       const clickedMedia = clickedSlide.querySelector("[data-media-id]");
//       if (!clickedMedia) return;

//       const targetMediaId = clickedMedia.dataset.mediaId;

//       // Find matching slide in main slider
//       const mainSlides = this.settings.sliderInstance.slides;
//       for (let i = 0; i < mainSlides.length; i++) {
//         const mainSlide = mainSlides[i];
//         if (mainSlide.dataset.mediaId === targetMediaId) {
//           this.settings.sliderInstance.slideTo(i);
//           break;
//         }
//       }
//     });
//   }

//   updateThumbnailActiveState(mainSwiper) {
//     const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
//     if (!activeSlide) return;

//     const activeMediaId = activeSlide.dataset.mediaId;

//     this.thumbSwiper.slides.forEach((thumbSlide) => {
//       const thumbMedia = thumbSlide.querySelector("[data-media-id]");

//       if (thumbMedia && thumbMedia.dataset.mediaId === activeMediaId) {
//         thumbSlide.classList.add("swiper-slide-thumb-active");
//       }
//     });
//   }
//   syncThumbnails(mainSwiper) {
//     if (!this.thumbSwiper) return;

//     const realIndex = mainSwiper.realIndex;
//     this.updateThumbnailActiveState(mainSwiper);

//     this.thumbSwiper.slideToLoop(realIndex, 300);
//   }

//   connectedCallback() {
//     this.init();
//   }

//   init() {
//     if (!this.settings.sliderElement) return;
//     this.settings.sliderInstance = new Swiper(
//       this.settings.sliderElement,
//       this.settings.options
//     );
//   }

//   setActiveModalOpener(swiper) {
//     const activeSlide = swiper.slides[swiper.activeIndex];
//     if (!activeSlide) return;
//     const activeMediaId = activeSlide.dataset.mediaId;
//     this.querySelector(
//       `${this.selectors.modalOpeners}.is-active`
//     )?.classList.remove("is-active");
//     this.querySelector(
//       `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
//     )?.parentElement.classList.add("is-active");
//     if (activeSlide.dataset.mediaType === "model") {
//       this.querySelector(this.selectors.btnXr).dataset.shopifyModel3dId =
//         activeMediaId;
//     }
//   }
// }

// customElements.define("product-media", ProductMedia);
